import { send } from '../builder/multiquery.client';
import { Query } from '../builder/query';
import { getInstance } from '../../../auth/authWrapper';
import { getCurrentCguAndClientLastTermQuery } from '../queries/cgu.queries';
import { getCurrentCguAuthorization } from '../../api/cgu/cgu.authorizations';
import { getClientLastTermAuthorization } from '../../api/client/client.authorizations';

export default function getCurrentCGURequest() {
    const authService = getInstance();
    const auth0Id = authService.user.sub;
    return send({
        queries: [
            new Query(getCurrentCguAndClientLastTermQuery(auth0Id), 'cgu')
        ],
        authorizations: [
            getCurrentCguAuthorization(),
            getClientLastTermAuthorization()
        ],
        headers: {
            'X-AUTH-ROLES': 'CLIENT_GET_LAST_CGU'
        }
    });
}
